const COMPONENT_NAME = "collapsible-faq";
const CLASS_SELECTOR = ".CollapsibleFAQ";
const ANSWER_SELECTOR = ".CollapsibleFAQ-answer";
const INNER_SELECTOR = ".CollapsibleFAQ-answerInner";
const CLASS_OPEN = "is-open";

// NEW: anything that should behave normally (no toggle)
const INTERACTIVE_SELECTOR = "a, button, [role='button'], input, select, textarea, label";


const instances = [];

function toggle(element) {
    element.classList.toggle(CLASS_OPEN);
    const isOpen = element.classList.contains(CLASS_OPEN);
    const container = element.querySelector(ANSWER_SELECTOR);
    const inner = element.querySelector(INNER_SELECTOR);
    container.style.height = (isOpen ? inner.offsetHeight : 0) + 'px';
}
function initialize(element, PageComponents) {
    element.addEventListener(
        'click',
        (e) => {
            const inAnswer = e.target.closest(ANSWER_SELECTOR);
            const interactive = e.target.closest(INTERACTIVE_SELECTOR);

            // If the click is on an interactive control inside the answer,
            // let it behave normally (do not block, do not toggle).
            if (inAnswer && interactive) {
                return; // allow default + bubbling to the control (e.g., navigate)
            }
            
            e.stopPropagation();
            e.preventDefault();
            toggle(element);
        }
    );
    instances.push(element);

    // fixme: Need to make this not specific to Warframe
    if (Warframe && Warframe.addDataLayerListener) {
        Warframe.addDataLayerListener({
            element,
            event: 'click',
            payload: {
                event: 'accordion_click',
                creative_type: 'accordion',
                creative_title: `faq-${Array.from(element.parentNode.children).indexOf(element) + 1}`,
                creative_placement: Warframe.detectAnalyticsPlacement(element),
            },
            transform: (e, p) => {
                const isOpen = element.classList.contains('is-open');
                p.creative_title = isOpen ? 'open' : 'close';
            },
        })
    }
}

module.exports = {
    name: COMPONENT_NAME,
    instances,
    initialize
};
